import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ActivateAccountModalComponent } from './activate-account-modal.component';

@Component({
    selector: 'app-login-module',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {

    private username: string;
    private password: string;
    private maskedEmail: string;
    private returnUrl: string;
    private invalidLogin = false;
    private missingLogin = false;
    private forgotPasswordSent = false;
    private noAccountFound = false;
    private today = new Date();

    loggingIn = false;

    constructor(private auth: AuthService, private router: Router, private route: ActivatedRoute, private dialog: MatDialog) { }

    ngOnInit() {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/account';
     }

    clearErrors(): void {
        this.invalidLogin = false;
        this.loggingIn = true;
        this.missingLogin = false;
        this.noAccountFound = false;
    }

    signin(): void {
        this.clearErrors();

        this.password = this.password.trim();

        this.auth
            .login(this.username, this.password)
            .subscribe((valid: boolean) => {
                if (valid) {
                    this.router.navigateByUrl(this.returnUrl);
                    return;
                }
                this.invalidLogin = true;
            },
                error => {
                    this.invalidLogin = true;
                    this.loggingIn = false;
                },
                () => {
                    this.loggingIn = false;
                });
    }

    private padLeft(nr, n, str) {
        return Array(n - String(nr).length + 1).join(str) + nr;
    }

    showActivateAccountModal(): void {
        this.dialog.open(ActivateAccountModalComponent, {
            width: '625px'
        });
    }

    forgotPassword(): void {

        if (!this.username) {
            this.missingLogin = true;
            return;
        }

        if (this.auth.checkUsername(this.username)) {

            this.auth.forgotPassword(this.username)
                .subscribe(response => {
                    this.clearErrors();

                    if (response.email) {
                        this.forgotPasswordSent = true;
                        const split = response.email.split('@');
                        this.maskedEmail = this.padLeft('@' + split[1], response.email.length - 1, '*');
                    } else {
                        this.noAccountFound = true;
                    }
                    this.loggingIn = false;
                });
        } else {
            this.invalidLogin = true;
        }

        this.loggingIn = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts